import { UserIcon } from '@heroicons/react/24/outline'
import { isEmpty } from '@life/model'
import { classNames } from '../classNames'
import { IconWithToolTip } from './IconWithToolTip'

type Props = {
  color?: 'green' | 'red'
  className?: string
}
export function PersonIcon({ color = 'green', className }: Props): JSX.Element {
  return (
    <UserIcon
      className={classNames(className, 'h-4', color === 'green' && 'text-green-700', color === 'red' && 'text-red-700')}
    />
  )
}

type WithToolTipProps = {
  count: number
}
export function PersonIconWithToolTip({ count }: WithToolTipProps): JSX.Element {
  return (
    <IconWithToolTip icon={<PersonIcon color={count > 0 ? 'green' : 'red'} />}>
      <div className="whitespace-nowrap">{XPeopleToEnglish(count)}</div>
    </IconWithToolTip>
  )
}

function XPeopleToEnglish(count: number): string {
  if (isEmpty(count)) return 'No one'
  if (count === 1) return '1 person'
  return `${count} people`
}
